import { render, staticRenderFns } from "./FundSeatEdit.vue?vue&type=template&id=05065e58"
import script from "./FundSeatEdit.vue?vue&type=script&lang=js"
export * from "./FundSeatEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports